import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance
const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" }
});

// Attach admin token if present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token && config.url?.includes("/admin/") && !config.url?.includes("/admin/login")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ================================
// Public form APIs
// ================================
export const submitAdmission = (data) => client.post("/admissions", data).then((r) => r.data);
export const submitContact = (data) => client.post("/contacts", data).then((r) => r.data);
export const submitFranchise = (data) => client.post("/franchise", data).then((r) => r.data);
export const submitCareer = (data) => client.post("/careers", data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);

// ================================
// Admin APIs
// ================================
export const adminLogin = async (username, password) => {
  const res = await client.post("/admin/login", { username, password });
  const { access_token } = res.data;
  localStorage.setItem("adminToken", access_token);
  return res.data;
};

export const adminLogout = () => localStorage.removeItem("adminToken");
export const isAdminLoggedIn = () => Boolean(localStorage.getItem("adminToken"));

export const adminMe = () => client.get("/admin/me").then((r) => r.data);
export const adminStats = () => client.get("/admin/stats").then((r) => r.data);
export const adminList = (type) => client.get(`/admin/${type}`).then((r) => r.data);
export const adminUpdateStatus = (type, id, status) =>
  client.patch(`/admin/${type}/${id}/status`, { status }).then((r) => r.data);
